import { Dispatch, SetStateAction } from "react";
import CloseIcon from "@mui/icons-material/Close";
import {  Modal } from "@mui/material";

interface ModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function SuccessVendorForm({ open, onClose, setOpen }: ModalProps) {
  return (
    <Modal className="modal success_modal" open={open} onClose={onClose}>
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="btn-close" onClick={() => setOpen(false)}>
            <CloseIcon />
          </div>
          <div className="success_content">
            <figure><img src="/static/images/success_image.png" alt="Icon" /></figure>
            <h2 className="md_5">Woo hoo!</h2>
            <p>You have successfully submited form for review.</p>
          </div>
        </div>
      </div>
    </Modal>
  );
}
